const BASE_URL = "/circuit-breaker";
const BASE_URL_ALLOWLIST = `${BASE_URL}/allowlist`;

export const PAGE_URLS = {
  allowlist: `${BASE_URL_ALLOWLIST}`,
  allowlistCreate: `${BASE_URL_ALLOWLIST}/create`,
  blocklist: `${BASE_URL}/blocklist`,
  riskRules: `${BASE_URL}/risk-rules`,
} as const;
